import { CadastroVendedor } from './../interfaces/cadastro-vendedor';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Cadastro } from '../interfaces/cadastro';

import { FatDoctoC } from '../interfaces/fat-docto-c';
import { MovtoDetails } from '../interfaces/movto-details';
import { Endereco } from '../interfaces/endereco';
import { Observable, of } from 'rxjs';
import { PageResult } from '../interfaces/page-result';

import * as cnpjValidator from '@fnando/cnpj';
import { JwtAuthService } from './auth/jwt-auth.service';
import { CadastroProjection } from '../interfaces/cadastro-projection copy';

/**
 * Created by Eldevan Nery Junior on 15/11/2020-15:40:10
 */
@Injectable({
  providedIn: 'root'
})
export class CadastroService {

  readonly path = '/cadastro';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {}

  saveOrUpdateCliente(cadastro: Cadastro): Observable<Cadastro> {
    return this.http.put<Cadastro>(`${this.jwtAuthService.apiUrl + this.path}/cliente`, cadastro);
  }

  create(): Observable<Cadastro> {
    return this.http.post<Cadastro>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  saveOrUpdate(cadastro: Cadastro): Observable<Cadastro> {
    return this.http.put<Cadastro>(`${this.jwtAuthService.apiUrl + this.path}/v2`, cadastro);
  }

  getCadastroFisica(cpf: string, rg: string): Observable<Cadastro> {
    return this.http.get<Cadastro>(`${this.jwtAuthService.apiUrl + this.path}/fisica?cpf=${cpf}&rg=${rg}`);
  }

  getCadastroJuridica(cnpj: string, inscricao: string): Observable<Cadastro> {
    return this.http.get<Cadastro>(`${this.jwtAuthService.apiUrl + this.path}/juridica?cnpj=${cnpj}&inscricao=${inscricao}`);
  }

  getCadastroJuridicaCert(cnpj: string, uf: string): Observable<any> {
    if (cnpj != null && cnpj !== '') {
      cnpj = cnpj.replace(/\D/g, '');
    }
    if (cnpj !== '') {
      if (cnpjValidator.isValid(cnpj)) {
        return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/juridica/cert?cnpj=${cnpj}&uf=${uf}`);
      }
    }
    return of({});
  }

  getCadastroJuridicaProxy(cnpj: string): Observable<any> {
    if (cnpj != null && cnpj !== '') {
      cnpj = cnpj.replace(/\D/g, '');
    }
    if (cnpj !== '') {
      if (cnpjValidator.isValid(cnpj)) {
        
        return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/juridica/proxy?cnpj=${cnpj}`);
      }
    }
    return of({});
  }


  getCadastro(id: number): Observable<Cadastro> {
    return this.http.get<Cadastro>(`${this.jwtAuthService.apiUrl + this.path}/?cadastroId=${id}`);
  }

  deleteCadastro(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }


  getCadastroPage(page?: number, size?: number, order?: string,
    direction?: string, desativado?: boolean, tipoCadastro?: string): Observable<PageResult<Cadastro>> {
    return this.http.get<PageResult<Cadastro>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/v2?page=${page}&size=${size}`
      + `&order=${order}&direction=${direction ?? 'ASC'}&desativado=${desativado ?? false}&tipoCadastro=${tipoCadastro ?? 'TODOS'}`);
  }

  getCadastroProjectionPage(page?: number, size?: number, order?: string, direction?: string, desativado?: boolean, tipoCadastro?: string): Observable<PageResult<CadastroProjection>> {
    return this.http.get<PageResult<CadastroProjection>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/projection?page=${page}&size=${size}`
      + `&order=${order}&direction=${direction ?? 'ASC'}&desativado=${desativado ?? false}&tipoCadastro=${tipoCadastro ?? 'TODOS'}`);
  }

  getCadastroPageSearch(page?: number, size?: number,
    search?: string, order?: string, direction?: string, desativado?: boolean, tipoCadastro?: string): Observable<PageResult<Cadastro>> {
    return this.http.get<PageResult<Cadastro>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/v2?page=${page}&size=${size}&search=${search}`
      + `&order=${order}&direction=${direction ?? 'ASC'}&desativado=${desativado ?? false}&tipoCadastro=${tipoCadastro ?? 'TODOS'}`);
  }

  getCadastroProjectionPageSearch(page?: number, size?: number, search?: string, order?: string, direction?: string, desativado?: boolean, tipoCadastro?: string): Observable<PageResult<CadastroProjection>> {
    return this.http.get<PageResult<CadastroProjection>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/projection?page=${page}&size=${size}&search=${search}`
      + `&order=${order}&direction=${direction ?? 'ASC'}&desativado=${desativado ?? false}&tipoCadastro=${tipoCadastro ?? 'TODOS'}`);
  }

  getMovto(page?: number, size?: number, order?: string, direction?: string, cadastroId?: string,
    dataInicial?: string, dataFinal?: string): Observable<PageResult<FatDoctoC>> {
    return this.http.get<PageResult<FatDoctoC>>(`${this.jwtAuthService.apiUrl + this.path}/movto/page/get/v2?page=${page}&size=${size}`
      + `&cadastroId=${cadastroId}&dataInicial=${dataInicial}&dataFinal=${dataFinal}&order=${order}&direction=${direction}`);
  }

  getMovtoDetails(cadastroId: string): Observable<MovtoDetails> {
    return this.http.get<MovtoDetails>(`${this.jwtAuthService.apiUrl + this.path}/movto/details?cadastroId=${cadastroId}`);
  }

  getPageEndereco(page?: number, size?: number, order?: string,
    direction?: string, cadastroId?: string): Observable<PageResult<Endereco>> {
    return this.http.get<PageResult<Endereco>>(`${this.jwtAuthService.apiUrl + this.path}/endereco/page/get/?page=${page}&size=${size}`
      + `&cadastroId=${cadastroId}&order=${order}&direction=${direction ?? 'ASC'}`);
  }

  getPageVendedor(page?: number, size?: number, order?: string,
    direction?: string, cadastroId?: string): Observable<PageResult<CadastroVendedor>> {
    return this.http.get<PageResult<CadastroVendedor>>(`${this.jwtAuthService.apiUrl + this.path}/vendedor/page/get/?page=${page}&size=${size}`
      + `&cadastroId=${cadastroId}&order=${order}&direction=${direction ?? 'ASC'}`);
  }

  saveOrUpdateEndereco(endereco: Endereco): Observable<Endereco> {
    return this.http.put<Endereco>(`${this.jwtAuthService.apiUrl + this.path}/endereco`, endereco);
  }

  deleteCadastroEndereco(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/endereco/${id}`);
  }
  saveOrUpdateVendedor(cadastroVendedor: CadastroVendedor): Observable<CadastroVendedor> {
    return this.http.put<CadastroVendedor>(`${this.jwtAuthService.apiUrl + this.path}/vendedor`, cadastroVendedor);
  }

  deleteCadastroVendedor(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/vendedor/${id}`);
  }




}
